import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { blueGrey } from '@mui/material/colors';

export const APP_BAR_HEIGHT = 60;

export const TEXT_PRIMARY = blueGrey[700];

export const StyledAppContainer = styled(Box)({
  height: '100%',
  width: '100%',
  margin: 0,
  padding: 0,
});
